import { writable } from "svelte/store";
import { get } from "svelte/store";

type Mode = "live" | "test" | "demo" | "editor";

type ModeStore = {
  mode: Mode;
}

export const setMode = (mode: Mode) => {
  modeStore.update((data: ModeStore) => ({ ...data, mode }));
};

export const getMode = () => get(modeStore).mode;

export const isLiveMode = () => getMode() === "live";
export const isTestMode = () => getMode() === "test";
export const isDemoMode = () => getMode() === "demo" || getMode() === "editor";
export const isEditorMode = () => getMode() === "editor";

export const initStore = () => {
  const store = writable<ModeStore>();
  store.set({ mode: import.meta.env.FOOJI_MODE as Mode || "live" });
  return store;
};

export const modeStore = initStore();
